/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminListingAnalytics,
    AdminListingAnalyticsFromJSON,
    AdminListingAnalyticsFromJSONTyped,
    AdminListingAnalyticsToJSON,
} from './AdminListingAnalytics';
import {
    AdminListingSeverity,
    AdminListingSeverityFromJSON,
    AdminListingSeverityFromJSONTyped,
    AdminListingSeverityToJSON,
} from './AdminListingSeverity';

/**
 * 
 * @export
 * @interface AdminAttentionProduct
 */
export interface AdminAttentionProduct {
    /**
     * 
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    asin?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    daysListed: number;
    /**
     * Full-size primary image, for previews.
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    listingNumber: number;
    /**
     * worst first
     * @type {Array<AdminListingAnalytics>}
     * @memberof AdminAttentionProduct
     */
    listings: Array<AdminListingAnalytics>;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    lowestResalePrice: number;
    /**
     * MarketCapturedAt is when the newest market data of the product was taken; null without one.
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    marketCapturedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    maxGapRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    msrp: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    productId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    purchasePrice: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAttentionProduct
     */
    soldCount: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAttentionProduct
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {AdminListingSeverity}
     * @memberof AdminAttentionProduct
     */
    worstSeverity: AdminListingSeverity;
}



export function AdminAttentionProductFromJSON(json: any): AdminAttentionProduct {
    return AdminAttentionProductFromJSONTyped(json, false);
}

export function AdminAttentionProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAttentionProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'daysListed': json['daysListed'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'listingNumber': json['listingNumber'],
        'listings': ((json['listings'] as Array<any>).map(AdminListingAnalyticsFromJSON)),
        'lowestResalePrice': json['lowestResalePrice'],
        'marketCapturedAt': !exists(json, 'marketCapturedAt') ? undefined : json['marketCapturedAt'],
        'maxGapRatio': !exists(json, 'maxGapRatio') ? undefined : json['maxGapRatio'],
        'msrp': json['msrp'],
        'name': json['name'],
        'productId': json['productId'],
        'purchasePrice': json['purchasePrice'],
        'soldCount': json['soldCount'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'worstSeverity': AdminListingSeverityFromJSON(json['worstSeverity']),
    };
}

export function AdminAttentionProductToJSON(value?: AdminAttentionProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'daysListed': value.daysListed,
        'imageUrl': value.imageUrl,
        'listingNumber': value.listingNumber,
        'listings': ((value.listings as Array<any>).map(AdminListingAnalyticsToJSON)),
        'lowestResalePrice': value.lowestResalePrice,
        'marketCapturedAt': value.marketCapturedAt,
        'maxGapRatio': value.maxGapRatio,
        'msrp': value.msrp,
        'name': value.name,
        'productId': value.productId,
        'purchasePrice': value.purchasePrice,
        'soldCount': value.soldCount,
        'thumbnailUrl': value.thumbnailUrl,
        'worstSeverity': AdminListingSeverityToJSON(value.worstSeverity),
    };
}

